import { extractAccountNumber } from "./Utils";

export const processICICIStatement = ({
  rawData,
  file,
  setAccountName,
  setAccountNo,
  setStatmentFile,
  setTransactions,
  setTotalWithdrawal,
  setTotalDeposit,
  setTotalEntery,
  setLoading,
  errorAlert,
}) => {
  try {
    if (!rawData[2][1] || !rawData[4][1]) {
      throw new Error("Statement does not match the selected bank account!!");
    }

    setAccountName(rawData[2][1]);
    setAccountNo(rawData[4][1]);

    const getTxn = rawData.slice(16);

    const tempTxn = [];
    for (let i = 0; i < getTxn.length; i++) {
      const ele = getTxn[i];
      if (ele.length === 0) {
        const finalData = tempTxn
          .map((row) => ({
            sNo: row[0],
            date: row[3],
            particulars: row[6],
            instNo: row[5],
            withdrawal: parseFloat(row[7]) || 0,
            deposit: parseFloat(row[8]) || 0,
            balance: row[9],
          }))
          .filter((row) => row.sNo)
          .slice(1);

        if (finalData.length === 0) {
          errorAlert("Invalid Excel!!");
        }

        setStatmentFile(file);
        setTransactions(finalData);
        setTotalWithdrawal(
          finalData.reduce((sum, row) => sum + row.withdrawal, 0)
        );
        setTotalDeposit(finalData.reduce((sum, row) => sum + row.deposit, 0));
        setTotalEntery(finalData.length);
        return;
      }
      tempTxn.push(ele);
    }
  } catch (error) {
    errorAlert("Statement does not match the selected bank account!!");
  } finally {
    setLoading(false);
  }
};

export const processAxisStatement = ({
  rawData,
  file,
  setAccountName,
  setAccountNo,
  setStatmentFile,
  setTransactions,
  setTotalWithdrawal,
  setTotalDeposit,
  setTotalEntery,
  setLoading,
  errorAlert,
}) => {

  try {
    const accName = rawData[0][0];
    const accountNumber = extractAccountNumber(rawData[11][0]);

    if (!accName || !accountNumber) {
      throw new Error("Invalid Excel!!");
    }

    const getName = accName.replace(/^Name\s*[:-]\s*/, "").trim();
    setAccountName(getName);
    setAccountNo(accountNumber);

    const tempArr = [];
    let tempText = [];

    for (let i = 0; i < rawData.length; i++) {
      const ele = rawData[i];

      if (ele[0] === "\t") {
        tempText.push("\t");
        if (tempText.length === 2) break;
      }

      if (tempText.length === 1 && ele[0] !== "\t") {
        tempArr.push(ele);
      }
    }

    const tempTxn = tempArr.map((ele, index) => ({
      sNo: index,
      date: ele[1],
      particulars: ele[4],
      instNo: ele[3],
      withdrawal: ele[6] === "DR" ? parseFloat(ele[5]) || 0 : 0,
      deposit: ele[6] === "CR" ? parseFloat(ele[5]) || 0 : 0,
      balance: ele[7],
    }));

    const txnData = tempTxn.slice(1);

    if (txnData.length === 0) {
      errorAlert("Invalid Excel!!");
    }

    setStatmentFile(file);
    setTransactions(txnData);
    setTotalWithdrawal(txnData.reduce((sum, row) => sum + row.withdrawal, 0));
    setTotalDeposit(txnData.reduce((sum, row) => sum + row.deposit, 0));
    setTotalEntery(txnData.length);
  } catch (error) {
    errorAlert("Statement does not match the selected bank account!!");
  } finally {
    setLoading(false);
  }
};

export const processRepublicStatement = ({
    rawData,
    file,
    setAccountName,
    setAccountNo,
    setStatmentFile,
    setTransactions,
    setTotalWithdrawal,
    setTotalDeposit,
    setTotalEntery,
    setLoading,
    errorAlert,
  }) => {
    try {
      const accName = rawData[0][0];
      const accountNumber = extractAccountNumber(rawData[1][0]);
  
      if (!accName || !accountNumber) {
        throw new Error("Invalid Excel!!");
      }
  
      const getName = accName.replace(/^Name\s*[:-]\s*/, "").trim();
      setAccountName(getName);
      setAccountNo(accountNumber);
  
      const headerIndex = rawData.findIndex(row =>
        row.includes("Date") && row.includes("Cheque No.") && row.includes("Payee")
      );
  
      if (headerIndex === -1 || headerIndex + 1 >= rawData.length) {
        throw new Error("Invalid Republic bank format");
      }
  
      const tempArr = rawData.slice(headerIndex + 1);
      const tempTxn = [];
  
      for (let i = 0; i < tempArr.length; i++) {
        const ele = tempArr[i];
        if (!ele || ele.length < 6) continue;
  
        tempTxn.push({
          sNo: i + 1,
          date: ele[0],
          instNo: ele[1],
          particulars: `${ele[2]} - ${ele[3]}`,
          withdrawal: ele[4] < 0 ? Math.abs(ele[4]) : 0,
          deposit: ele[4] > 0 ? ele[4] : 0,
          balance: null,
          remarks: ele[5] || "",
        });
      }
  
      if (tempTxn.length === 0) {
        errorAlert("Invalid Excel!!");
      }
  
      setStatmentFile(file);
      setTransactions(tempTxn);
      setTotalWithdrawal(tempTxn.reduce((sum, row) => sum + row.withdrawal, 0));
      setTotalDeposit(tempTxn.reduce((sum, row) => sum + row.deposit, 0));
      setTotalEntery(tempTxn.length);
    } catch (error) {
      console.error(error);
      errorAlert("Statement does not match the selected bank account!!");
    } finally {
      setLoading(false);
    }
  };
















///////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////
//   // ICICI Bank Processing
//   const processICICI = (rawData, file) => {
//     // debugger;
//     try {
//       if (!rawData[2][1] || !rawData[4][1]) {
//         throw new Error("Statement does not match the selected bank account!!");
//       }
//       setAccountName(rawData[2][1]);
//       setAccountNo(rawData[4][1]);

//       const getTxn = rawData.slice(16);

//       const tempTxn = [];
//       for (let i = 0; i < getTxn.length; i++) {
//         const ele = getTxn[i];
//         if (ele.length === 0) {
//           const finalData = tempTxn
//             .map((row) => ({
//               sNo: row[0],
//               date: row[3],
//               particulars: row[6],
//               instNo: row[5],
//               withdrawal: parseFloat(row[7]) || 0,
//               deposit: parseFloat(row[8]) || 0,
//               balance: row[9],
//             }))
//             .filter((row) => row.sNo)
//             .slice(1);

//           if (finalData.length === 0) {
//             errorAlert("Invalid Excel!!");
//           }
//           setStatmentFile(file);
//           setTransactions(finalData);
//           setTotalWithdrawal(
//             finalData.reduce((sum, row) => sum + row.withdrawal, 0)
//           );
//           setTotalDeposit(finalData.reduce((sum, row) => sum + row.deposit, 0));
//           const tempEntery = finalData.length;
//           setTotalEntery(tempEntery);
//           return;
//         }
//         tempTxn.push(ele);
//       }
//     } catch (error) {
//       errorAlert("Statement does not match the selected bank account!!");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const extractAccountNumber = (str) => {
//     const match = str.match(/Account No\s*[-]?\s*(\d+)/);
//     return match ? match[1] : null;
//   };
//   // Axis Bank Processing
//   const processAxis = (rawData, file) => {
//     try {
//       const accName = rawData[0][0];
//       const accountNumber = extractAccountNumber(rawData[11][0]);
//       if (!accName || !accountNumber) {
//         throw new Error("Invalid Excel!!");
//       }
//       const getName = accName?.replace(/^Name\s*[:-]\s*/, "").trim();
//       setAccountName(getName);
//       setAccountNo(accountNumber);

//       const tempArr = [];
//       let tempText = [];
//       for (let i = 0; i < rawData.length; i++) {
//         const ele = rawData[i];
//         console.log(ele, ele[0]);
//         if (ele[0] === "\t") {
//           tempText.push("\t");
//           if (tempText.length === 2) {
//             break;
//           }
//         }
//         if (tempText.length === 1 && ele[0] !== "\t") {
//           tempArr.push(ele);
//         }
//       }

//       const tempTxn = [];
//       for (let i = 0; i < tempArr.length; i++) {
//         const ele = tempArr[i];
//         tempTxn.push({
//           sNo: i,
//           date: ele[1],
//           particulars: ele[4],
//           instNo: ele[3],
//           withdrawal: ele[6] === "DR" ? ele[5] : 0,
//           deposit: ele[6] === "CR" ? ele[5] : 0,
//           balance: ele[7],
//         });
//       }
//       const txnData = tempTxn.slice(1);

//       if (txnData.length === 0) {
//         errorAlert("Invalid Excel!!");
//       }
//       setStatmentFile(file);
//       setTransactions(txnData);
//       setTotalWithdrawal(txnData.reduce((sum, row) => sum + row.withdrawal, 0));
//       setTotalDeposit(txnData.reduce((sum, row) => sum + row.deposit, 0));
//       const tempEntery = txnData.length;
//       setTotalEntery(tempEntery);
//       setLoading(false);
//     } catch (error) {
//       setLoading(false);
//       errorAlert("Statement does not match the selected bank account!!");
//     }
//   };